import React from "react";
import { gsap } from "gsap";
import { useLayoutEffect } from "react";
import { useRef } from "react";
import styles from "./Discord.module.scss";
import discordIcon from "../../img/discord/discord.png";
import tree from "../../img/discord/tree.png";
const Discord = ({ discordRef }) => {
  const treeRef = useRef();
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.matchMedia().add(
        "(min-width:1441px)",
        () => {
          gsap.fromTo(
            treeRef.current,
            {
              bottom: "-200px",
              duration: 2,
            },
            {
              bottom: "0px",
              scrollTrigger: {
                trigger: discordRef.current,
                start: "60% 100%",
                end: "80% 90%",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 2,
            }
          );
        },
        treeRef
      );
      gsap.matchMedia().add(
        "(min-width:769px) and (max-width:1440px)",
        () => {
          gsap.fromTo(
            treeRef.current,
            {
              bottom: "-13.89vw",
            },
            {
              bottom: "0vw",
              scrollTrigger: {
                trigger: discordRef.current,
                start: "40% 70%",
                end: "bottom bottom",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        treeRef
      );
      gsap.matchMedia().add(
        "(min-width:481px) and (max-width:768px)",
        () => {
          gsap.fromTo(
            treeRef.current,
            {
              bottom: "-10vw",
            },
            {
              bottom: "9.11vw",
              scrollTrigger: {
                trigger: discordRef.current,
                start: "30% 80%",
                end: "80% bottm",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        treeRef
      );

      gsap.matchMedia().add(
        "(max-width: 480px)",
        () => {
          gsap.fromTo(
            treeRef.current,
            {
              bottom: "-10vw",
            },
            {
              bottom: "13.13vw",
              scrollTrigger: {
                trigger: discordRef.current,
                start: "50% 80%",
                end: "80% bottm",
                scrub: true,
                snap: false,
                pinSpacing: false,
                markers: false,
              },
              duration: 4,
            }
          );
        },
        treeRef
      );
    });
    return () => ctx.revert();
  });

  return (
    <div className={styles.container} ref={discordRef}>
      <div className={styles.contents_box}>
        <img className={styles.tree} src={tree} alt="" ref={treeRef} />
        <h1 data-content="Join Our Discord Giveaway">
          Join Our Discord Giveaway
        </h1>
        <div>
          <p>Want to win some AirPods?</p> Join our Discord for a chance to win
          and be part of a great community to stay up to date with everything
          hyper-casual.
        </div>
        <a
          href="https://discord.gg/Cf6smsvk7a"
          target="_blank"
          rel="noreferrer"
        >
          <img className={styles.discord} src={discordIcon} alt="discord" />
          <span>
            <p>MondayOFF</p>
            <p>Join Our Discord</p>
          </span>
        </a>
      </div>
    </div>
  );
};

export default Discord;
